<template>
  <div>
    <el-container class="navdiv">
      <div class="navimgdiv">
         <img class="navimg" src="../assets/nav/navlogo.png" alt="">
      </div>
      <el-main class="navdivp">
         <div class="grid-content bg-purple-light">
              <el-menu
              :default-active="activeIndex"
              class="el-menu-demo"
              mode="horizontal"
              @select="handleSelect"
              text-color="#FFFFFF"
              background-color="#040404"
              active-text-color="#FFFFFF"
              >
              <el-menu-item index="1" class="nav1"  @click="jump(0)"><a  >首页</a></el-menu-item>
              <el-menu-item index="2" class="nav1"  @click="jump(2)"><a  >产品服务</a></el-menu-item>
              <el-menu-item index="3" class="nav1"  @click="jump(1)"><a  >关于芯创</a></el-menu-item>
              <el-menu-item index="4" class="nav1"  @click="jump(3)"><a  >联系芯创</a></el-menu-item>
            </el-menu>
            </div>
      </el-main>
    </el-container>


    <el-container class="moomdiv section">
      <div class="navbg">
        <vue-particles
          color="#dedede"
          :particleOpacity="0.5"
          :particlesNumber="200"
          shapeType="polygon"
          :particleSize="1"
          linesColor="#FFFFFF"
          :linesWidth="2"
          :lineLinked="true"
          :lineOpacity="0"
          :linesDistance="150"
          :moveSpeed="3"
          :hoverEffect="true"
          hoverMode="repulse"
          :clickEffect="true"
          clickMode="push"
        ></vue-particles>
      </div>
      <el-main  class="stare">
        <img class="moomimg" src="../assets/nav/moom.png" alt="">
        <p class="moompc">
          致力于未来数字化场景有温度的连接
        </p>
        <p class="moompe">
          FOCUSING ON THE HUMANIZED CONNECTION IN FUTURE DIGITAL SCENES
        </p>
        <a  >
        <div class="nav1 "  @click="jump(1)" style="padding-top: 1vw;">
          <p style="margin-bottom: 0.5vw;">START</p>
          <img src="../assets/nav/stare.png" alt="">  
        </div>
        </a>
      </el-main>
    </el-container>


    <el-container class="section">
      <el-container>
        <el-main>
            <el-col :span="21" class="aboutlift">
              <div class="grid-content bg-purple-light">
                <p class="aboutp1">XINCHUANG AIOT</p>
                <p class="aboutp2">HUMANIZED</p>
                <p class="aboutp2">CONNECTION WITH AI</p>
                <p class="aboutp3">芯创物联是一家以传统产业场景为依托，聚焦产业数字化场景研发、制造、流行,助推产业数字化转型，首创国内数字化产业赋能EPC新模式，拥有50+技术专利的国家高新技术企业。</p>
                <div>
                  <div class="aboutdiv">
                    <img class="aboutimg" src="../assets/about/cube.png" alt="">
                    <p class="aboutp4">数字赋能研发</p>
                  </div>
                  <div class="aboutdiv">
                    <img class="aboutimg" src="../assets/about/ai.png" alt="">
                    <p class="aboutp4">数字商业大脑</p>
                  </div>
                  <div class="aboutdiv">
                    <img class="aboutimg" src="../assets/about/bank.png" alt="" style="width:4.8em;">
                    <p class="aboutp4">产业数据银行</p>
                  </div>
                </div>
              </div>
            </el-col>
            <el-col :span="3"><div class="grid-content bg-purple"></div></el-col>
          </el-main>
      </el-container>
    </el-container>

    <el-container class="section">
      <el-container>
        <el-container>
          <el-main>
          <div>
             <img class="producimg " src="../assets/nav/line.png" alt="">
          </div>
          <div class="producdiv">
            <p class="producpe" >PRODUCT SERVICES</p>
            <p class="producpc">产品服务</p>
          </div>
          <div class="producpcb">聚焦3大产业数字赋能IOC领域</div>
          </el-main>
        </el-container>
      </el-container>
    </el-container>

    <el-container class="produccontainer">
      <el-container>
         <el-container>
            <el-main class="produccontainerdiv1">
              <div class="produccontainerdiv">
                <p class="produccontainerp">数字赋能研发</p>
                <p class="producp">· 家庭健康大脑</p>
                <p class="producp">· 数字美学大脑</p>
                <p class="producp">· 教育大脑</p>
                <p class="producp">· 数字化社区</p>
                <p class="producp">· 智慧写字楼</p>
                <p class="producp">· 数字化治理</p>
              </div>   
            </el-main>
            <el-main class="produccontainerdiv2">
               <div class="produccontainerdiv">
                  <p class="produccontainerp">数字商业大脑</p>
                  <p class="producp">· 数字营销大脑</p>
                  <p class="producp">· 产业大数据模型</p>
                  <p class="producp">· 产业AIGC</p>
                  <p class="producp">· 舆情模型</p>
                  <p class="producp">· 数字化工具</p>
               </div>
            </el-main>
            <el-main class="produccontainerdiv3">
               <div class="produccontainerdiv">
                  <p class="produccontainerp">产业数据银行</p>
                  <p class="producp">· 产业数据测评</p>
                  <p class="producp">· 企业数据激活</p>
                  <p class="producp">· 企业智能体诊断</p>
                  <p class="producp">· 企业智能体搭建</p>
                  <p class="producp">· 企业数据托管</p>
                  <p class="producp">· 企业数据资产投资</p>
               </div>
            </el-main>
          </el-container>
      </el-container>
    </el-container>

    <el-container>
      <el-container>
        <el-container>
          <el-main>
          <div>
             <img class="producimg" src="../assets/nav/line.png" alt="">
          </div>
          <div class="producdiv">
            <p class="producpe" >PRODUCT SERVICES</p>
            <p class="producpc">精英团队</p>
          </div>
          <div class="producpcb">云集人工智能领域专家，智联未来</div>
          </el-main>
        </el-container>
      </el-container>
    </el-container>

    <el-container>
      <el-container>
        <el-container>
          <el-main>
            <div class="team">
              芯创旗下“3+X”实验室，分别专注于人工智能、工业设计、智慧生活场景及前沿技术研发及追踪，以科技创造美好生活。核心成员拥有BAT、上市企业、剑桥、MIT等资深背景，并携手国外AIOT领域专家、工业设计团队，为用户提供更具温度的产品服务。             
            </div>
             <img class="teamimg" src="../assets/product/team.png" alt="">
          </el-main>
        </el-container>
      </el-container>
    </el-container>


    <el-container>
      <el-container>
        <el-container>
          <el-main>
          <div>
             <img class="producimg" src="../assets/nav/line.png" alt="">
          </div>
          <div class="producdiv">
            <p class="producpe" >COOPERATIVE PARTNER</p>
            <p class="producpc">商务合作伙伴</p>
          </div>
          <div class="producpcb">携手共创，智赢未来</div>
          </el-main>
        </el-container>
      </el-container>
    </el-container>


    <el-container class="partnerdiv">
      <el-container>
          <el-main>
            <img class="partner" src="../assets/cooperation/ali.png" alt="">
            <img class="partner" src="../assets/cooperation/kk.png" alt="">
            <img class="partner" src="../assets/cooperation/sm.png" alt="">
          </el-main>
           <el-main>
            <img class="partner" src="../assets/cooperation/hw.png" alt="">
            <img class="partner" src="../assets/cooperation/xmwlw.png" alt="">
            <img class="partner" src="../assets/cooperation/wk.png" alt="">
          </el-main>
          <el-main>
            <img class="partner" src="../assets/cooperation/boe.png" alt="">
            <img class="partner" src="../assets/cooperation/smfc.png" alt="">
            <img class="partner" src="../assets/cooperation/dnk.png" alt="">
          </el-main>
          <el-main>
            <img class="partner" src="../assets/cooperation/yzs.png" alt="">
            <img class="partner" src="../assets/cooperation/mfjt.png" alt="">
            <img class="partner" src="../assets/cooperation/gmdc.png" alt="">
          </el-main>
           <el-main>
            <img class="partner" src="../assets/cooperation/hkws.png" alt="">
            <img class="partner" src="../assets/cooperation/rndc.png" alt="">
            <img class="partner" src="../assets/cooperation/fjwl.png" alt="">
          </el-main>
        </el-container>
    </el-container>

    <el-container>
      <el-container>
        <el-container class="section">
          <el-main class="casebtnsdiv" >
            <img class="netImg" src="../assets/case/net.png" alt="">
            <div style="line-height:1;font-size:1.458vw;color: #CAC8C8;">芯创物联产业数字赋能落地案例</div>
            <div style="line-height:1;font-size:3.2vw;margin-top: 5.364vw;">不动产数字赋能实验室</div>
            <div style="line-height:1;font-size:2vw;margin-top: 2.03125vw;">不动产数字赋能领跑者</div>
            <a class="casebtn" href="http://dichan.xciot365.com">
              点击查看不动产数字赋能实验室介绍
              <img class="fingerimg" src="../assets/case/finger.png" alt="">
            </a>
            <div class="caseIcons">
              <el-popover
                placement="bottom-start"
                width="160"
                trigger="hover"
                v-model="visible">
                <div style="text-align: center;margin-bottom: 10px;line-height: 1.2">
                  <img class="caseimg" src="../assets/case/qr_douyin.png" alt="">
                  <div>使用抖音扫一扫</div>
                </div>
                <div class="item" slot="reference">
                  <img class="icon" src="../assets/case/icon1.png" alt="">
                  抖音
                </div>
              </el-popover>
              <el-popover
                placement="bottom-start"
                width="160"
                trigger="hover"
                v-model="visible2">
                <div style="text-align: center;margin-bottom: 10px;line-height: 1.2">
                  <img class="caseimg" src="../assets/case/qr_hongshu.png" alt="">
                  <div>使用微信扫一扫</div>
                </div>
                <div class="item" slot="reference">
                  <img class="icon" src="../assets/case/icon2.png" alt="">
                  小红书
                </div>
              </el-popover>
              <el-popover
                placement="bottom-start"
                width="160"
                trigger="hover"
                v-model="visible3">
                <div style="text-align: center;margin-bottom: 10px;line-height: 1.2">
                  <img class="caseimg" src="../assets/case/qr_shipin.jpg" alt="">
                  <div>使用微信扫一扫</div>
                </div>
                <div class="item" slot="reference">
                  <img class="icon" src="../assets/case/icon3.png" alt="">
                  视频号
                </div>
              </el-popover>
            </div>
          </el-main>
        </el-container>
      </el-container>
    </el-container>

    <el-container class="case">
      <el-container>
        <el-container>
          <el-main>
          <div>
             <img class="producimg" src="../assets/nav/lineb.png" alt="">
          </div>
          <div class="producdiv">
            <p class="producpe casee" >COOPERATION CASES</p>
            <p class="producpc casec">合作案例</p>
          </div>
          </el-main>
        </el-container>
      </el-container>
    </el-container>

    <el-container class="casediv">
      <el-container>
          <div>
            <img class="caseimg" src="../assets/case/wkbc.png" alt="">
            <img class="caseimg" src="../assets/case/gmry.png" alt="">
            <img class="caseimg" src="../assets/case/wf.png" alt="">
          </div>
          <div>
            <img class="caseimg" src="../assets/case/kj.png" alt="">
            <img class="caseimg" src="../assets/case/ioi.png" alt="">
            <img class="caseimg" src="../assets/case/ys.png" alt="">
          </div>
          <div>
            <img class="caseimg" src="../assets/case/hs.png" alt="">
            <img class="caseimg" src="../assets/case/ss.png" alt="">
            <img class="caseimg" src="../assets/case/yg.png" alt="">
          </div>
        </el-container>
    </el-container>
     <el-container>
      <el-container>
        <el-container>
          <el-main>
            <div class="bottomdiv">
               <img class="bottomimglog" src="../assets/bottom/xclogo@2x.png" alt="">
               <div class="bottomp1">领跑产业数字化赋能</div>
               <div style="float: left;">
                <div class="bottomp2">中国·厦门</div>
                <div class="bottomp3">福建省，厦门市，湖里区</div>
                <div class="bottomp3">高崎南五路222号航空商务广场7号楼</div>
               </div>
               <div style="float: right;">
                <div class="bottomp2">联系我们</div>
                <div class="bottomp3">芯创数字赋能官：</div>
                <div class="bottomp3">18965820938（微信同号） </div>
               </div>
             </div>
          </el-main>
        </el-container>
      </el-container>
      <template >
        <div >
          <hr class="bottomhr" SIZE=1>
        </div>
      </template>
      <el-footer class="bottomgs">©️ 2019 厦门芯物联科技有限公司 版权所有  <a style="color: #E3E3E3;" href="https://beian.miit.gov.cn/">闽ICP备19009895号-1</a> </el-footer>
    </el-container>
    <div class="scrollTop" v-show="showTop" @click="toTop">
      <img class="scrollTopimg" src="../assets/bottom/back.png"/>
    </div>

  </div>
</template>

<script>
document.querySelector('html').style.fontSize = '2vmin'
export default {
  name: 'Home',
  data () {
    return {
      msg: 'Welcome to Your Vue.js App',
      activeIndex: '1',
      visible: false,
      visible2: false,
      visible3: false,
      scrollTop: 0,
      time: 0,
      dParams: 20,
      scrollState: 0
    }
  },

  computed:{
    showTop: function(){
      let value = this.scrollTop>200?true:false;
      return value;
    },
  },

  mounted() {
    window.addEventListener('scroll', this.getScrollTop);
  },

  methods: {
      handleSelect(key, keyPath) {
        console.log(key, keyPath);
      },
      toTop(e) {
        if(!!this.scrollState){
          return;
        }
        this.scrollState = 1;
        e.preventDefault();
        let distance = document.documentElement.scrollTop || document.body.scrollTop;
        let _this = this;
        this.time = setInterval(function(){ _this.gotoTop(_this.scrollTop-_this.dParams) }, 10);
      },
      gotoTop(distance){
        this.dParams += 20;
        distance = distance>0 ? distance : 0;
        document.documentElement.scrollTop = document.body.scrollTop = window.pageYOffset = distance;
        if(this.scrollTop < 10){
          clearInterval(this.time);
          this.dParams = 20;
          this.scrollState = 0;
        }
      },
      getScrollTop() {
        this.scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      },

      dataScroll: function () {
        this.scroll = document.documentElement.scrollTop || document.body.scrollTop;
      },
      jump(index) {
          console.log(index)
          let jump = document.getElementsByClassName('section');
          // 获取需要滚动的距离
          let total = jump[index].offsetTop;
          // Chrome
          document.body.scrollTop = total;
          // Firefox
          document.documentElement.scrollTop = total;
          // Safari
          window.pageYOffset = total;
          // $('html, body').animate({
          // 'scrollTop': total
          // }, 400);
      },
      loadSroll: function () {
            var self = this;
            var $navs = $(".nav1");
            var sections = document.getElementsByClassName('section');
              for (var i = sections.length - 1; i >= 0; i--) {
                  if (self.scroll >= sections[i].offsetTop - 100) {
                      $navs.eq(i).addClass("current").siblings().removeClass("current")
                      break;
                  }

              }
        }
      },
    watch: {
        scroll: function () {
            this.loadSroll()
        }
    },
    mounted() {
      window.addEventListener('scroll', this.dataScroll);
    }


}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .stare{
    z-index: 1;
  }
  .scrollTopimg{
    width: 3.5em;
  }
  .scrollTop {
    position: fixed;
    right: 2.5em;
    bottom: 5em;
    cursor: pointer;
  }
 .el-main {
    /* background-color: #E9EEF3; */
    /* color: #333; */
    text-align: center;
    padding: 0px;
    /* line-height: 160px; */
  }
  .navdiv{
    /* padding-top: 25px; */
    /* padding-bottom: 20px; */
    position: fixed;
    width: 100%;
    background: #040404;
    z-index: 10;
  }
  .navdivbg{
    height: 3.75em;
  }
  .navimgdiv{
    margin: auto;
    width: 30%;
    text-align: right;
  }
  .navimg{
    width: 40%;
    margin:1% 0% 1% 0%;
  }
  .navdivp{
    padding-left: 10%;
    overflow: hidden;
  }
  .el-menu-item{
    padding: 0 3%;
  }
  .navbg{
   position: absolute;
    width: 100%;
    top: 3.75em;
  }
  .moomdiv{
    /* position: absolute; */
    /* width: 100%; */
    /* top: 20%; */
     background-image: url(../assets/nav/navbg.png);
     padding-bottom: 5%;
     padding-top: 10%;
  }
  .moomimg{
   margin-top: 4em;
    width: 20%;
  }
  .moompc{
    font-size:2.25em;
    margin-top: 4%;
  }
  .moompe{
    font-size: 1.23em;
  }
  .aboutlift{
    background-image: url(../assets/about/about.png);
    background-repeat:no-repeat;
    /* background-position:right; */
    background-size: 100% 100%;
    color: #343434;
    padding-left: 10%;
    padding-right: 10%;
    text-align: left;
  }
  .aboutp1{
    font-size: 0.8em;
    font-weight: bold;
    line-height: 5em;
  }
  .aboutp2{
    font-size:  4.8em;
    font-weight: bold;
    margin: 0px;
  }
  .aboutp3{
    font-size: 1.75em;
    color: #999;
    margin-top: 2em;
    text-align: justify;
  }
  .aboutp4{
    font-size: 1.25em;
  }
  .aboutdiv{
    margin-top: 2em;
    font-size: 1.25em;
    display: inline-block;
    margin-bottom: 2em;
    width: 30%;
  }
  .aboutimg{
    width: 4em;
  }
  .producimg{
   margin-top: 11em;
   width: 10em;
  }
  .producp{
    margin: 0px;
    line-height: 1.7em;
  }
  .producpe{
    font-size: 4.3em;
    color: #363636;
    margin: 0px;
  }
  .producpc{
    font-size:  3em;
    position: absolute;
    top: 0.1em;
    width: 100%;
    margin: 0px;
  }
  .producpcb{
    font-size:  2.1em;
    margin-bottom: 3em;
  }
  .producdiv{
    position: relative;
    margin: 2em;
  }
  .produccontainer{
    padding-left: 10%;
    padding-right: 10%;
  }
  .produccontainerdiv1{
    background-image: url(../assets/product/family.png);
    background-repeat:no-repeat;
    background-size: 100% 100%;
    font-size: 1.5em;
    padding: 3% 5% 5% 5%;

  }
   .produccontainerdiv2{
    background-image: url(../assets/product/business.png);
    background-repeat:no-repeat;
    background-size: 100% 100%;
    margin-left: 3%;
    margin-right: 3%;
    font-size:1.5em;
    padding: 3% 5% 5% 5%;
  }
  .produccontainerdiv3{
    background-image: url(../assets/product/number.png);
    background-repeat:no-repeat;
    background-size: 100% 100%;
    font-size: 1.5em;
    padding: 3% 5% 5% 5%;
  }
  .produccontainerdiv{
    text-align: left;
    display: inline-block;
  }
  .produccontainerp{
    font-size: 1.2em;
  }
  .team{
    font-size: 1.6em;
    text-align: justify;
    padding: 0% 15% 10% 15%;
    line-height: 1.6em;
  }
  .teamimg{
    width: 60%;
  }
  .partner{
    display:block;
    margin: auto;
    padding-bottom: 2em;
    width: 80%;
  }
  .partnerdiv{
    /* padding-left: 5%;
    padding-right: 5% */
    padding: 3% 2% 3% 2%;
    background-image: url(../assets/cooperation/partnerbg.png);
    background-repeat:no-repeat;
    background-size: 100% 100%;
  }
  .case{
    background: #FFFFFF;
  }
  .casee{
    color: #C5C5C5;
  }
  .casec{
    color: #333333;
  }
  .casediv{
    background: #FFFFFF;
    padding: 5% 5% 5% 5%;
    white-space: wrap;
  }
  .casediv .caseimg {
    width: 26.40625vw;
    height: 17.7604vw;
  }

  .casebtnsdiv {
    width: 100vw;
    height: 32.91vw;
    position: relative;
    margin-top: 1.875vw;
    padding-left: 8.125vw;
    padding-top: 3vw;
    box-sizing: border-box;
    text-align: left;
  }

  .casebtnsdiv .netImg {
    width: 40vw;
    position: absolute;
    right: 12.24vw;
    top: 4.271vw;
  }

  .casebtn {
    border-radius: 2.8vw;
    border: 1px solid #FFFFFF;
    font-size: 1.25vw;
    line-height: 1.25vw;
    color: #E3E3E3;
    position: relative;
    margin-top: 3.75vw;
    padding: .8333vw 4.1666vw .8333vw 2vw;
    text-align: left;
    letter-spacing: 1px;
    display: inline-block;
    text-decoration: none;
  }

  .casebtn .fingerimg {
    position: absolute;
    right: 1.25vw;
    top: .8854vw;
    width: 1.8229vw;
  }

  .casebtnsdiv .caseIcons .item {
    float: left;
    display: flex;
    align-items: center;
    margin-right: 4.21875vw;
    margin-top: 2.9166vw;
    font-size: 1.25vw;
    color: #CAC8C8;
    cursor: pointer;
  }

  .casebtnsdiv .caseIcons .icon {
    width: 3.177vw;
    height: 3.177vw;
    margin-right: .4166vw;
  }

  .caseimg{
    width: 100%;
  }
  .bottomdiv{
    text-align: left;
    height: 26.35vw;
    padding: 3.75vw 7.03125vw 0;
    box-sizing: border-box;
  }
  .bottomp{
    font-size: 1.25em;
  }
  .bottomp1{
    font-size: 2.344vw;
    font-weight: 600;
    margin: 1.4583vw 0 3.9583vw 31.4583vw;
  }
  .bottomp2{
    font-size: 1.5625vw;
    font-weight: bold;
    margin-bottom: 1.8vw;
  }
  .bottomp3{
    font-size: 1.25vw;
  }
  .bottomhr{
    display: inline-block;
    width: 85.9375%;
    color: #D6D6D6; 
  }
  .bottomgs{
    color: #E3E3E3;
    font-size: 0.6875em;
  }
  .bottomimglog{
    width: 17.708vw;
    display: block;
    margin-left: 31.4583vw;
  }
  .el-menu--horizontal>.el-menu-item.is-active{
    font-size: 1.4em;
  }
  .el-menu-item{
    font-size:  0.8em;
  }
  .el-menu.el-menu--horizontal {
    border: none
  }
 .el-header, .el-footer {
    /* background-color: #B3C0D1; */
    /* color: #333; */
    text-align: center;
    /* line-height: 60px; */
  }

  .el-aside {
    background-color: #D3DCE6;
    color: #333;
    text-align: center;
    line-height:  12.5em;
  }


  body > .el-container {
    margin-bottom: 2.5em;
  }

  .el-container:nth-child(5) .el-aside,
  .el-container:nth-child(6) .el-aside {
    line-height: 16.25em;
  }

  .el-container:nth-child(7) .el-aside {
    line-height: 20em;
  }
  .el-row {
    /* margin-bottom: 20px; */

  }
  .el-col {
    /* border-radius: 4px; */
  }
  .bg-purple-dark {
    background: #99a9bf;
  }
  .bg-purple {
    /* background: #d3dce6; */
  }
  .bg-purple-light {
    /* background: #e5e9f2; */
  }
  .grid-content {
    border-radius: 4px;
    min-height: 2.25em;
  }
  .row-bg {
    padding: 0.625em 0;
    background-color: #f9fafc;
  }
  .el-popover {
    padding: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/Home.vue